export * from "./osm.tagset";
export * from "./osm.colorResolver";
export * from "./osm.interfaces";
export * from "./osm.interfaces.building";
export * from "./osm.interfaces.road";
export * from "./osm.interfaces.water";
export * from "./osm.interfaces.forest";
//# sourceMappingURL=index.js.map